<template>
    <div class="container">
        <div v-if="0 == isSettleIn" class="c-success">
          <img src="../../assets/maker/success-in.png" alt="">
          <div class="c-success-btn"
               ref="dragElement1"
               @mousedown="startDrag($event, 1)"
               @touchstart="startDrag($event, 1)"
               :style="dragStyle1">
            <img class="c-success-btn-kf" src=".././../assets/maker/icon_qe.png" @click.stop="openService" />
          </div>
        </div>
        <div v-else-if="2 == isSettleIn" class="c-success">
          <img src="../../assets/maker/success-error.png" alt="">
          <div class="c-success-btn"
               ref="dragElement2"
               @mousedown="startDrag($event, 2)"
               @touchstart="startDrag($event, 2)"
               :style="dragStyle2">
            <img class="c-success-btn-kf" src=".././../assets/maker/icon_qe.png" @click.stop="openService" />
          </div>
          <div class="bh-title">驳回理由：</div>
          <div class="bh-remark">{{ applyRemark }}</div>
          <div class="bh-perfect" @click="openShop">去完善资料  ></div>
        </div>
        <div class="content" v-else>
            <div class="tab-box">
                <img class="top-img" :src="`${miniUrl}/ck-head.png`" />
                <div class="tab">
                    <div
                        class="tab-item"
                        :class="{ 'tab-item__active': tabIndex === curIndex }"
                        v-for="(tab, tabIndex) in tabs"
                        @click="onTabClick(tabIndex)"
                        :key="tab.id">{{ tab.name }}</div>
                </div>
            </div>
            <div class="gap" />
            <section v-show="curIndex === 0" class="intro-box">
                <div class="btn-box">
                    <img class="btn-img" :src="`${miniUrl}/zdhz_1.png`" />
                    <!-- :class="[fixedBtn ? 'fixed-btn' : 'submit-btn']" -->
                    <div :class="['fixed-btn']">
                        <div class="btn-animate btn" @click="openShop"></div>
                        <img class="finger-img pointer-move" src="../../assets/maker/hand.png" />
                    </div>
                </div>
                <img class="intro-img" :src="`${miniUrl}/zdhz_2.png`" />
                <img class="img" :src="`${miniUrl}/zdhz_3.png`" />
                <img class="desc-img" :src="`${miniUrl}/zdhz_4.png`" />
                <img class="desc-img" :src="`${miniUrl}/zdhz_5.png`" />
                <img class="desc-img" :src="`${miniUrl}/zdhz_6.png`" />
            </section>
            <section class="join-box" v-show="curIndex === 1">
                <!-- <img class="join-img" :src="`${imgUrl}/register/6.png`" /> -->
                <div class="linkage-count">
                    <img class="linkage-img" :src="`${miniUrl}/xftg_1.png`" />
                    <!-- :class="[fixeLinkage ? 'fixed-linkage' : 'linkage-btn']" -->
                    <div :class="['fixed-linkage']">
                        <div class="linkage-box btn-animate" @click="openShop">
                            <!-- <span>点击注册</span> -->
                            <!-- <div class="container">
                                <div class="dot"></div>
                                <div class="pulse"></div>
                                <div class="pulse1"></div>
                            </div> -->
                        </div>
                        <img class="finger-img pointer-move" src="../../assets/maker/hand.png" />
                    </div>
                    <img class="linkage-img" :src="`${miniUrl}/xftg_2.png`"/>
                    <img class="linkage-img" :src="`${miniUrl}/xftg_3.png`" />
                    <img class="linkage-img" :src="`${miniUrl}/xftg_4.png`" />
                </div>
            </section>
            <section class="join-box" v-show="curIndex === 2">
                <img class="join-img" :src="`${miniUrl}/smjs_1.png`" />
                <!-- :class="[fixed ? 'fixed-btn' : 'join-btn-box']" -->
                <div :class="['fixed-btn']">
                    <div class="btn-animate smjs-btn" @click="openShop"></div>
                    <img class="finger-img pointer-move" src="../../assets/maker/hand.png" />
                </div>
                <img class="join-img" :src="`${miniUrl}/smjs_2.png`" />
                <img class="join-img" :src="`${miniUrl}/smjs_3.png`" />
                <img class="join-img" :src="`${miniUrl}/smjs_4.png`" />
            </section>
            <section class="join-box" v-show="curIndex === 3">
                <img class="join-img" style="margin-bottom: 0 !important;" :src="`${miniUrl}/dxgw_1.png`" />
                <!-- :class="[fixed ? 'fixed-btn' : 'join-btn-box']" -->
                <div :class="['fixed-btn']">
                    <div class="btn-animate join-btn" @click="openShop"></div>
                    <img class="finger-img pointer-move" src="../../assets/maker/hand.png" />
                </div>
                <img class="join-img" style="margin-bottom: 0 !important;" :src="`${miniUrl}/dxgw_2.png`" />
                <img class="join-img" style="margin-bottom: 0 !important;" :src="`${miniUrl}/dxgw_3.png`" />
            </section>
            <section class="join-box" v-show="curIndex === 4">
                <img class="join-img" style="margin-bottom: 0 !important;" :src="`${miniUrl}/hxzj_1.png`" />
                <!-- :class="[fixed ? 'fixed-btn' : 'join-btn-box']" -->
                <div :class="['fixed-btn']">
                    <div class="btn-animate join-btn" @click="openShop"></div>
                    <img class="finger-img pointer-move" src="../../assets/maker/hand.png" />
                </div>
                <img class="join-img" style="margin-bottom: 0 !important;" :src="`${miniUrl}/hxzj_2.png`" />
                <img class="join-img" style="margin-bottom: 0 !important;" :src="`${miniUrl}/hxzj_3.png`" />
            </section>
        </div>
    </div>
</template>

<script>
    import { ref, computed, getCurrentInstance, onMounted, onBeforeUnmount } from 'vue'
    import { useRouter } from 'vue-router'
    import { debounce } from '@/utils/util'
    import { customerService } from "@/utils/getCustomerService"
    import { getUrlKey } from '@/utils/util'
    import { Dialog  } from 'vant'
    export default {
        name: 'register-guide',
        setup() {
            const { proxy } = getCurrentInstance()
            const router = useRouter()
            const curIndex = ref(0)
            const scrollTop = ref(0)
            const offsetTop = ref(0)
            const imgUrl = ref('https://image.jxt1314.com/h5')
            const miniUrl = ref('https://image.jxt1314.com/mini/maker')
            const isSettleIn = ref(false)
            const linkageTop = ref(0)
            // 添加拖动相关的状态
            const dragElement1 = ref(null);
            const dragElement2 = ref(null);
            const dragStyle1 = ref({
                position: 'fixed',
                bottom: '170px',
                right: '32px',
                cursor: 'move',
                zIndex: 999
            });
            const dragStyle2 = ref({
                position: 'fixed',
                bottom: '170px',
                right: '32px',
                cursor: 'move',
                zIndex: 999
            });
            let isDragging = false;
            let currentDragIndex = 0;
            let offsetX = 0;
            let offsetY = 0;
            const margin = 16; // 距离边界的最小距离
            const tabs = ref([
                {
                    id: 0,
                    name: '招店合作'
                },
                {
                    id: 3,
                    name: '消费推广'
                },
                {
                    id: 1,
                    name: '私密技师'
                },
                {
                    id: 2,
                    name: '店销顾问'
                },
                {
                    id: 4,
                    name: '会销专家'
                }
            ])

            const onTabClick = (index) => {
                curIndex.value = index
                // 直接滚动到顶部
                window.scrollTo(0, 0)
            }

            const openShop = () => {
                router.replace({
                    path: '/maker',
                    query: {
                      id: getUrlKey('id'),
                      from: getUrlKey('from')
                    }
                })
            }

            const fixedBtn = computed(() => scrollTop.value > 250)
            const fixed = computed(() => offsetTop.value > 225)
            const fixeLinkage = computed(() => linkageTop.value > 206)
            const applyRemark = ref('')

            const getMakerInfo = () => {
              const params = {
                user_from: Number(getUrlKey('from')),
                user_id: Number(getUrlKey('id'))
              }
              proxy.$http.post('/h5/fans_maker/get_by_user_id', params).then(({ data: res }) => {
                if (res?.success) {
                  isSettleIn.value = res?.data?.apply_estate
                  applyRemark.value = res?.data?.apply_remark
                } else {
                  isSettleIn.value = 3
                }
              }).catch(err => console.log('err', err))
            }
            const openService = () => {
              const isWxMiniProgram = window.__wxjs_environment === 'miniprogram' || navigator.userAgent.indexOf('miniProgram') > -1;
                if(isWxMiniProgram) {
                  proxy.$http.post('/base/kefu').then(({ data: res }) => {
                    if (res?.success) {
                        const data = res.data
                        data.id = getUrlKey('id')
                        data.from = getUrlKey('from')
                        customerService(data)
                    } else {
                        proxy.$toast(res.errorMessage)
                    }
                  }).catch(err => console.log('err', err))
                } else {
                  Dialog({
                    title: '提示',
                    message: '是否需要联系客服？',
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    confirmButtonColor: '#3363DE',
                    cancelButtonColor: '#C7C7C7',
                }).then( () => {
                    proxy.$http.post('/base/kefu').then(({ data: res }) => {
                      if (res?.success) {
                          const data = res.data
                          data.id = getUrlKey('id')
                          data.from = getUrlKey('from')
                          customerService(data)
                      } else {
                          proxy.$toast(res.errorMessage)
                      }
                    }).catch(err => console.log('err', err))
                }).catch(() => {
                  proxy.$toast('已取消')
                });
              }
           }
            onMounted(() => {
              window.addEventListener('scroll', debounce(() => {
                if (curIndex.value === 0) {
                  scrollTop.value = window.scrollY
                }
                if (curIndex.value === 1) {
                  linkageTop.value = window.scrollY
                }
                if (curIndex.value === 2) {
                  offsetTop.value = window.scrollY
                }
                if (curIndex.value === 3) {
                  offsetTop.value = window.scrollY
                }
                if (curIndex.value === 4) {
                  offsetTop.value = window.scrollY
                }
              }, 30))
              getMakerInfo()
            })

            onBeforeUnmount(() => {
                window.removeEventListener('scroll', () => {})
            })
            // 开始拖动
            const startDrag = (e, dragIndex) => {
                // 检查点击目标是否为客服按钮或其子元素
                const isClickOnButton = e.target.closest('.kf-body-btn');
                if (isClickOnButton) {
                    return; // 如果点击的是按钮区域，不执行拖动逻辑
                }
                isDragging = true;
                currentDragIndex = dragIndex;

                const touch = e.type === 'touchstart' ? e.touches[0] : e;
                const dragElement = dragIndex === 1 ? dragElement1.value : dragElement2.value;
                if (!dragElement) return;

                const rect = dragElement.getBoundingClientRect();
                offsetX = touch.clientX - rect.left;
                offsetY = touch.clientY - rect.top;

                document.addEventListener('mousemove', onDrag);
                document.addEventListener('touchmove', onDrag);
                document.addEventListener('mouseup', stopDrag);
                document.addEventListener('touchend', stopDrag);
            };
            // 拖动中
            const onDrag = (e) => {
                if (!isDragging) return;

                const touch = e.type === 'touchmove' ? e.touches[0] : e;
                const dragElement = currentDragIndex === 1 ? dragElement1.value : dragElement2.value;
                if (!dragElement) return;

                // 获取视窗尺寸
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;

                // 获取元素尺寸
                const elementWidth = dragElement.offsetWidth;
                const elementHeight = dragElement.offsetHeight;

                // 计算新位置（确保不超出边界）
                let newLeft = touch.clientX - offsetX;
                let newTop = touch.clientY - offsetY;

                // 限制在边界内，保留margin距离
                newLeft = Math.max(margin, Math.min(viewportWidth - elementWidth - margin, newLeft));
                newTop = Math.max(margin, Math.min(viewportHeight - elementHeight - margin, newTop));

                // 更新对应的元素位置
                const dragStyle = currentDragIndex === 1 ? dragStyle1 : dragStyle2;
                dragStyle.value.left = `${newLeft}px`;
                // 移除错误的right属性设置
                // dragStyle.value.right = `${newLeft + 32}px`;
                dragStyle.value.top = `${newTop}px`;
                // 移除bottom和right，避免冲突
                delete dragStyle.value.bottom;
                // delete dragStyle.value.right;
            };

            // 停止拖动
            const stopDrag = () => {
                isDragging = false;
                currentDragIndex = 0;
                document.removeEventListener('mousemove', onDrag);
                document.removeEventListener('touchmove', onDrag);
                document.removeEventListener('mouseup', stopDrag);
                document.removeEventListener('touchend', stopDrag);
            };

            return {
              curIndex,
              tabs,
              scrollTop,
              offsetTop,
              linkageTop,
              fixedBtn,
              fixed,
              imgUrl,
              miniUrl,
              fixeLinkage,
              openService,
              onTabClick,
              openShop,
              isSettleIn,
              applyRemark,
              dragElement1,
              dragElement2,
              dragStyle1,
              dragStyle2,
              startDrag
            }
        }
    }
</script>

<style scoped lang="scss">
    .container {
        width: 375px;
        margin: auto;
        .close-icon {
            position: fixed;
            top: 65px;
            right: 10px;
            z-index: 999;
        }
        .gap {
            height: 196px;
        }
        .content {
            border-radius: 20px 20px 0 0;
            // padding-bottom: 80px;
            overflow: hidden;

            .fixed-btn {
                width: 375px;
                height: 80px;
                position: fixed;
                left: 50%;
                bottom: 15px;
                z-index: 1000;
                // display: flex;
                // align-items: center;
                // justify-content: center;
                transform: translateX(-50%);
                padding-left: 45px;
            }

            .linkage-count {
                position: relative;
            }

            .fixed-linkage {
                width: 375px;
                height: 80px;
                position: fixed;
                left: 50%;
                bottom: 15px;
                z-index: 1000;
                // display: flex;
                // align-items: center;
                // justify-content: center;
                transform: translateX(-50%);
                padding-left: 45px;
            }

            .linkage-btn {
                width: 100vw;
                height: 80px;
                position: fixed;
                left: 0;
                top: 305px;
                z-index: 1000;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .linkage-box {
                width: 244px;
                height: 52px;
                // background: linear-gradient(180deg, #8F7971 0%, #342521 100%);
                // box-shadow: 0px 3px 6px 1px #D39C66;
                border-radius: 20px;
                opacity: 1;
                background-image: url('../../assets//maker/xftg_btn.png');
                background-size: 100% 100%;
                // border: 2px solid #FFEEDB;
                font-size: 16px;
                font-weight: bold;
                // color: #FFE9C9;
                text-align: center;
                line-height: 36px;
                position: relative;
                .circle-3 {
                    width: 10px;
                    height: 10px;
                    border: 1px solid #fff;
                    position: absolute;
                    right: 50px;
                    top: 50%;
                    transform: translateY(-50%);
                    border-radius: 50%;
                    // box-shadow: 0 0 10px #fff, 0 0 14px #fff, 0 0 32px #fff;
                    animation: circle-grow 1500ms linear infinite;
                }
            }
            @keyframes circle-grow {
                0% {
                    width: 0;
                    height: 0;
                    opacity: 1;
                }
                100% {
                    width: 32px;
                    height: 32px;
                    opacity: 0;
                }
            }
            .tab-box {
                width: 100%;
                height: 196px;
                position: fixed;
                left: 50%;
                top: 0;
                z-index: 1000;
                transform: translateX(-50%);

                .tab {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    display: flex;
                    align-items: flex-end;

                    &-item {
                        flex: 1;
                        background: #fff;
                        height: 35px;
                        line-height: 35px;
                        text-align: center;
                        border-radius: 8px 8px 0 0;
                        font-size: 14px;
                        box-shadow: 0px 3px 10px 1px rgba(0,0,0,0.16);
                        color: #666;
                        &__active {
                            height: 40px;
                            line-height: 40px;
                            color: #3E3F6E;
                            font-weight: bold;
                            font-size: 15px;
                        }
                    }
                }
            }

            .top-img {
                width: 100%;
                height: 100%;
            }

            .intro-box {
                overflow-x: hidden;
                // flex: 1;
                // height: calc(100vh - 162px);
                // padding-bottom: constant(safe-area-inset-bottom);
                // padding-bottom: env(safe-area-inset-bottom);
                // overflow-y: scroll;

                .intro-img {
                  width: 100%;
                }

                .img {
                    margin-top: -5px;
                    width: 100%;
                }

                .pb-15 {
                    padding-bottom: 15px;
                }

                .store-show {
                    background: #FAEFDC;
                    .show-box {
                      border-radius: 0 0 20px 15px;
                      overflow: hidden;
                      margin: -10px auto 0;
                      padding: 15px 0 0;
                      width: 351px;
                      background: #fffbf1;
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                    }
                    .show-img {
                      width: 345px;
                      height: 248px;
                    }

                    .icon {
                      width: 136px;
                      height: 14px;
                    }
                }

                .desc-img {
                  margin-top: -5px;
                  width: 375px;
                  display: flex;
                }
            }

            .join-box {
                // padding-bottom: constant(safe-area-inset-bottom);
                // padding-bottom: env(safe-area-inset-bottom);
                // overflow-y: scroll;
                // flex: 1;
                position: relative;

                .join-btn-box {
                    position: absolute;
                    left: 0;
                    top: 170px;
                    width: 375px;
                    height: 70px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .join-btn {
                  width: 244px;
                  height: 52px;
                  background: url('../../assets/maker/xftg_btn.png') no-repeat center center;
                  background-size: 100% 100%;
                  border-radius: 22px;
                }
                .smjs-btn {
                  width: 234px;
                  height: 44px;
                  background: url('../../assets/maker/smjs_btn.png') no-repeat center center;
                  background-size: 100% 100%;
                  border-radius: 22px;
                }

                .join-img {
                  width: 375px;
                  display: flex;
                }
            }

            .service-box {
                // flex: 1;
                // overflow-y: scroll;
                position: fixed;
                left: 50%;
                top: 162px;
                height: calc(100vh - 162px);
                width: 375px;
                padding-top: 20px;
                // background: #F6D246;
                transform: translateX(-50%);

                .join-guide {
                    // padding: 0 0 20px;
                    background: #fff;
                    border-radius: 10px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .guide-img {
                        margin: 20px 0 35px;
                        width: 323px;
                        //height: 222px;
                    }

                    .service-btn-box {
                        position: relative;
                        bottom: 50px;
                    }

                    .service-btn {
                        width: 310px;
                        height: 40px;
                        background: linear-gradient(90deg, #EB6A4A 0%, #E63B40 100%);
                        box-shadow: 0px 6px 10px 1px #F2C5BE;
                        border-radius: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #fff;
                        font: {
                            size: 16px;
                            weight: bold;
                        }
                    }

                    .service-icon {
                        position: absolute;
                        right: 45px;
                        bottom: 5px;
                        width: 67px;
                        height: 67px;
                    }
                }
            }

            .btn-box {
                position: relative;
                .submit-btn {
                    position: absolute;
                    left: 0;
                    bottom: 10px;
                    width: 375px;
                    height: 70px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .btn {
                    position: relative;
                    width: 234px;
                    height: 44px;
                    background: url('../../assets/maker/zdhz_btn.png') no-repeat center center;
                    background-size: 100% 100%;
                    border-radius: 22px;
                }

                .btn-img {
                    width: 100%;
                    display: flex;
                }
            }

            .btn-animate {
                -webkit-animation: scale-btn 1500ms steps(12) infinite;
                animation: scale-btn 1500ms steps(12) infinite;
            }

            .linkage-img {
                width: 100%;
                display: flex;
            }

            @-webkit-keyframes scale-btn {
                0% {
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }

                25% {
                    -webkit-transform: scale(1.05);
                    transform: scale(1.05);
                }

                50% {
                    -webkit-transform: scale(1.1);
                    transform: scale(1.1);
                }

                75% {
                    -webkit-transform: scale(1.05);
                    transform: scale(1.05);
                }

                100% {
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }
            }

            @keyframes scale-btn {
                0% {
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }

                25% {
                    -webkit-transform: scale(1.05);
                    transform: scale(1.05);
                }

                50% {
                    -webkit-transform: scale(1.1);
                    transform: scale(1.1);
                }

                75% {
                    -webkit-transform: scale(1.05);
                    transform: scale(1.05);
                }

                100% {
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }
            }

            .finger-img {
                position: absolute;
                bottom: 0px;
                right: 50px;
                width: 84px;
            }

            .pointer-move {
                animation-name: bottomMove, rightMove;
                animation-duration: 1500ms;
                animation-iteration-count: infinite;
                -webkit-animation-name: bottomMove, rightMove;
                -webkit-animation-duration: 1500ms;
                -webkit-animation-iteration-count: infinite;
            }

            @keyframes rightMove {
                50% {
                    animation-timing-function: linear;
                    -webkit-animation-timing-function: linear;
                    right: 25px;
                    bottom: -10px;
                }
            }

            @keyframes bottomMove {
                50% {
                    animation-timing-function: linear;
                    -webkit-animation-timing-function: linear;
                    right: -15px;
                    bottom: -40px;
                }
            }

            @-webkit-keyframes rightMove {
                50% {
                    animation-timing-function: linear;
                    -webkit-animation-timing-function: linear;
                    right: 25px;
                    bottom: -25px;
                }
            }

            @-webkit-keyframes bottomMove {
                50% {
                    animation-timing-function: linear;
                    -webkit-animation-timing-function: linear;
                    right: -15px;
                    bottom: -50px;
                }
            }
        }
    }


    @keyframes warn {
        0% {
            transform: scale(0.3);
            -webkit-transform: scale(0.3);
            opacity: 0.0;
        }
        25% {
            transform: scale(0.3);
            -webkit-transform: scale(0.3);
            opacity: 0.1;
        }
        50% {
            transform: scale(0.5);
            -webkit-transform: scale(0.5);
            opacity: 0.3;
        }
        75% {
            transform: scale(0.8);
            -webkit-transform: scale(0.8);
            opacity: 0.5;
        }
        100% {
            transform: scale(1);
            -webkit-transform: scale(1);
            opacity: 0.0;
            }
    }
    @keyframes warn1 {
        0% {
            transform: scale(0.3);
            -webkit-transform: scale(0.3);
            opacity: 0.0;
        }
        25% {
            transform: scale(0.3);
            -webkit-transform: scale(0.3);
            opacity: 0;
        }
        50% {
            transform: scale(0.3);
            -webkit-transform: scale(0.3);
            opacity: 0.5;
        }
        75% {
            transform: scale(0.4);
            -webkit-transform: scale(0.4);
            opacity: 0.5;
        }
        100% {
            transform: scale(0.4);
            -webkit-transform: scale(0.4);
            opacity: 0.0;
        }
    }
    @keyframes warn2 {
        0% {
            transform: scale(0.1);
            -webkit-transform: scale(0.1);
            opacity: 0.5;
        }
        25% {
            transform: scale(0.5);
            -webkit-transform: scale(0.5);
            opacity: 0.5;
        }
        50% {
            transform: scale(0.5);
            -webkit-transform: scale(0.5);
            opacity: 0;
        }
        75% {
            transform: scale(0.5);
            -webkit-transform: scale(0.5);
            opacity: 0.5;
        }
        100% {
            transform: scale(1);
            -webkit-transform: scale(1);
            opacity: 0.0;
        }
    }
    /* 保持大小不变的小圆点 */
    .dot {
        position: absolute;
        width: 10px;
        height: 10px;
        right: 54.5px;
        top: 34%;
        transform: translateY(-50%);
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border: 1px solid #ffffff;
        border-radius: 50%;
        // background-color:#33ccff; /* 实心圆 ，如果没有这个就是一个小圆圈 */
        z-index: 2;
        opacity: 0;
        -webkit-animation: warn2 1.5s ease-out;
        -moz-animation: warn2 1.5s ease-out;
        animation: warn2 1.5s ease-out;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        box-shadow: 1px 1px 30px #ffffff; /* 阴影效果 */
    }
    /* 产生动画（向外扩散变大）的圆圈 第一个圆 */
    .pulse {
        position: absolute;
        width: 35px;
        height: 35px;
        right: 42px;
        top: 0;
        transform: translateY(-50%);
        border: 1px solid #ffffff;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        z-index: 1;
        opacity: 0;
        -webkit-animation: warn 1.5s ease-out;
        -moz-animation: warn 1.5s ease-out;
        animation: warn 1.5s ease-out;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        box-shadow: 1px 1px 30px #ffffff; /* 阴影效果 */
    }
    /* 产生动画（向外扩散变大）的圆圈 第二个圆 */
    .pulse1 {
        position: absolute;
        width: 35px;
        height: 35px;
        right: 42px;
        top: 0;
        transform: translateY(-50%);
        border: 1px solid #ffffff;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        z-index: 1;
        opacity: 0;
        -webkit-animation: warn1 1.5s ease-out;
        -moz-animation: warn1 1.5s ease-out;
        animation: warn1 1.5s ease-out;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        box-shadow: 1px 1px 30px #ffffff; /* 阴影效果 */
    }
    .c-success {
        width: 375px;
        height: 100vh;
        position: relative;
        padding: 97px 45px 0 45px;
        text-align: center;
        img {
          width: 205px;
          margin: auto;
        }
        &-btn {
            position: absolute;
            right: 32px;
            z-index: 999;
            bottom: 300px;
            width: 50px;
            height: 50px;
            &-kf {
                width: 80px !important;
                height: 80px !important;
            }
        }
    }

    .bh-title {
      text-align: left;
      color: #000000;
      font-weight: 600;
      font-size: 16px;
    }

    .bh-remark {
      text-align: left;
      color: #000000;
      font-weight: 400;
      font-size: 14px;
      margin-top: 12px;
    }
    .bh-perfect {
      width: 203px;
      height: 32px;
      background: #A78CF1;
      border-radius: 8px;
      text-align: center;
      line-height: 32px;
      color: #fff;
      font-size: 14px;
      margin: 170px auto 0 auto;
    }
</style>
